function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, $hooks, Array, JSON, Object, String, document, keydownProxyEl, resourceType, searchFilter, selectedTab, stagedMenuType, stagedProperty, stagedSearchFilter, tooltipData) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const tabs = $helpers.getToggleTabs();;
    return {
      value: (h("div", {
        "class": {
          'mp-properties-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((stagedProperty) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu-pane", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'header': $helpers.getStagedMenuHeader(),
              'show-back-button': true,
            }),
            "on": {
              'back-click': $helpers.unstageProperty
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.isInnerContentSearchable()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'search-wrapper': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-input", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'icon': 'search',
                    'placeholder': `Search ${stagedProperty.name}...`,
                  }),
                  "props": {
                    value: stagedSearchFilter
                  },
                  "on": {
                    input: $helpers.handleSearchInput,
                  },
                  "hook": {
                    insert: $helpers.searchInputInserted
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'empty-message': `No items found`,
                'search-filter': stagedMenuType === $helpers.StagedMenuTypes.Dimension ? stagedSearchFilter : ``,
              }),
              "props": {
                sections: $helpers.getStagedMenuSections(),
                keydownProxyEl: document.body,
                /* allow keyboard navigation for selection */
              },
              "hook": {
                insert: $helpers.handleItemsMenuInsert,
              },
              "on": {
                clickItem: $helpers.applyStagedValue,
                clickPill: $helpers.onItemPillClick,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-properties-menu-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((tabs.length > 1) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'selected': selectedTab,
                  'theme': `tab-bar`,
                }),
                "key": `tabs-${tabs.length}` /* a terrible hack for adding mp-toggle children */ ,
                "on": {
                  select: $helpers.selectOption
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (tabs);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, tab, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            value: tab.value,
                            disabled: tab.disabled,
                          }),
                        }, [__vjadeSafeCode(tab.label)]));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var tab = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                value: tab.value,
                                disabled: tab.disabled,
                              }),
                            }, [__vjadeSafeCode(tab.label)]));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": __vjadeStringifyAttrsIfObj({
                name: `menu-header`
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'empty-message': `No items found`,
              'multiple': $helpers.useMultipleSelection(),
              'search-filter': searchFilter || $attr(`search-filter`),
              'show-select-all': $attr(`show-select-all`),
              'select-all-disabled': $attr(`select-all-disabled`),
            }),
            "on": {
              click: ev => ev.stopPropagation(),
              clickItem: $helpers.onItemClick,
              clickPill: $helpers.onItemPillClick,
              focusItem: $helpers.showItemDetails,
              selectAll: $helpers.onAllSelected,
            },
            "props": {
              keydownProxyEl,
              sections: $helpers.getMenuSections(),
              sectionsFromInputFn: (input, sections) => $helpers.sectionsFromInput(input, resourceType = selectedTab, sections),
              customSearchMatcherFn: $helpers.customSearchMatcherFn,
            },
            "hook": {
              insert: $helpers.handleItemsMenuInsert,
            },
          }));
          __jade_nodes = __jade_nodes.concat(($attr(`open`) && tooltipData) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
              "hook": {
                remove: $hooks.delayedAttrRemove(`tooltip-data`, null)
              },
              "attrs": __vjadeStringifyAttrsIfObj({
                'tooltip-data': JSON.stringify(tooltipData)
              }),
              "props": {
                tooltipPositionParentElement: $component.tooltipPositionParentElement
              },
              "on": {
                tooltipContextAction: $helpers.handleTooltipContextAction,
                tooltipContextEditDescription: $helpers.handleTooltipContextEditDescription
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)));
        __jade_nodes = __jade_nodes.concat(($attr(`apply-button`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button-bar", {
            "attrs": __vjadeStringifyAttrsIfObj({
              role: `button`,
              elref: `applyButton`,
              disabled: $attr(`apply-button-disabled`),
            }),
            "on": {
              click: $helpers.onApplyButtonClick,
            },
            "class": {
              'mp-button-bar-primary': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($attr(`apply-button`));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "document" in locals ? locals.document : typeof document !== "undefined" ? document : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "resourceType" in locals ? locals.resourceType : typeof resourceType !== "undefined" ? resourceType : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "selectedTab" in locals ? locals.selectedTab : typeof selectedTab !== "undefined" ? selectedTab : undefined, "stagedMenuType" in locals ? locals.stagedMenuType : typeof stagedMenuType !== "undefined" ? stagedMenuType : undefined, "stagedProperty" in locals ? locals.stagedProperty : typeof stagedProperty !== "undefined" ? stagedProperty : undefined, "stagedSearchFilter" in locals ? locals.stagedSearchFilter : typeof stagedSearchFilter !== "undefined" ? stagedSearchFilter : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;